<div class="main-content-wrapper">
	<div class="main-content">
		<header class="main-content-header">
			<h1 class="pull-left">
				<em *ngIf="loadingTitle" class="fas fa-circle-notch fa-spin"></em>
				<ng-container *ngIf="!loadingTitle">
					{{ title }}&nbsp;&nbsp;&nbsp;<a href="javascript:" (click)="loadShare()"><em class="fa fa-redo-alt"></em></a>
				</ng-container>
			</h1>
		</header>
	</div>
</div>
<div class="main-content-area" [ngClass]="{'loading in': loading }" *ngIf="!sharedItemsLoaded">&nbsp;</div>
<div class="main-content-area tall" [ngClass]="{'loading in': loading }" *ngIf="sharedItemsLoaded && ((sharedItems.length === 0 && permissions.indexOf(3) === -1) || !isValid)">
	<div class="message error">The M-Connect Share is invalid or has expired.</div>
</div>
<div class="main-content-area" #mainContentArea [ngClass]="{'hidden': !sharedItemsLoaded || (sharedItems.length === 0 && permissions.indexOf(3) === -1) || !isValid }">
	<div class="main-content-body" #leftContainer [ngClass]="{'loading in': loading, 'upload': showUpload || showRevision }">
		<!-- <cwx-uploader *ngIf="showUpload" class="external" (queue)="onUploadQueueChange($event)" [multiple]="true" [external]="true" [token]="token" [isForm]="true" [autopopulateName]="true" [useClassNameProp]="true" [defaultClass]="uploadClass" [allowUsersToAddProps]="false" (formObj)="onFormChange($event)" (formProps)="onPropertiesChange($event)"></cwx-uploader>
		<cwx-uploader *ngIf="showRevision" class="external" (queue)="onUploadQueueChange($event)" [multiple]="false" [external]="true" [isRevision]="true" [fileOnly]="true"></cwx-uploader>
		<div *ngIf="showUpload || showRevision" class="panelUploaderButtonDiv external">
			<button type="button" href="javascript:" (click)="cancelUpload()" class="btn btn-danger btn-md cancel">Cancel</button>
			<button type="button" href="javascript:" *ngIf="showUpload" class="icon-link btn btn-md btn-success cancel" [disabled]="!uploadFormValid || uploadFiles.length === 0" (click)="create()">Upload</button>
			<button type="button" href="javascript:" *ngIf="showRevision" class="icon-link btn btn-md btn-success cancel" [disabled]="view && view.files.length < 1" (click)="uploadRevision()">Upload Revision</button>
		</div> -->
		<ng-container *ngIf="permissions.indexOf(3) > -1 && uploadClass !== -1">
			<button [style.opacity]="!showUpload && !showRevision ? 1 : 0" type="button" class="btn btn-primary btn-md right" (click)="openUploader()">Upload</button>
			<input type="file" id="uploader" (change)="uploadFile($event)" multiple>
		</ng-container>
		<table [style.opacity]="!showUpload && !showRevision ? 1 : 0" class="full-width table table-striped table-fixed has-locked-deleted has-locked-and-deleted file-share-listing">
			<thead>
				<tr>
					<th id="name" class="title-cell">Name</th>
					<th id="revisions" *ngIf="permissions.indexOf(6) > -1"></th>
					<th id="share"></th>
					<th id="download"></th>
					<th id="delete" *ngIf="permissions.indexOf(10) > -1"></th>
					<th id="delete" *ngIf="permissions.indexOf(4) > -1"></th>
					<th id="coauthor" *ngIf="coauthorEnabled && permissions.indexOf(9) > -1"></th>
				</tr>
			</thead>
			<tbody>
				<tr class="inner download-button-row" *ngIf="sharedItems.length > 1 && permissions.indexOf(5) > -1">
					<td [attr.colspan]="getColCount()">
						<input class="download-button-row-checkbox" type="checkbox" id="checkAllInput" (change)="checkAll(sharedItems, $event)" />
						<div class="download-buttons">
							<button class="btn btn-primary download-button" [disabled]="!atLeastOneDocChecked(sharedItems) || isDocsDownloading()" (click)="downloadSelected(sharedItems)">Download Selected</button>
							<button class="btn btn-primary download-button" [disabled]="isDocsDownloading()" (click)="downloadAll(sharedItems)">Download All</button>
						</div>
					</td>
				</tr>
				<ng-container *ngFor="let sharedItem of sharedItems; let i = index;">
					<mfiles-row *ngIf="sharedItem.display" [autoSelect]="autoSelect && sharedItem.type == autoSelectType && sharedItem.id == autoSelectId" [item]="sharedItem" [view]="dataView" [objectTypes]="objectTypes" [objectTypeIcons]="objectTypeIcons" [icon]="objectTypeIcons[sharedItem.type] ? objectTypeIcons[sharedItem.type].changingThisBreaksApplicationSecurity : ''" [external]="true" [token]="token" [permissions]="permissions" [revisionsEnabled]="permissions.indexOf(6) > -1" [coauthorEnabled]="coauthorEnabled && permissions.indexOf(9) > -1" [removeFromShareEnabled]="permissions.indexOf(10) > -1" [deleteEnabled]="permissions.indexOf(4) > -1" [isAuthed]="isAuthed" (externalObjectSelected)="externalObjectSelected($event, i, 0, $event.fileIndex)" (uploaderOpened)="openCheckinForRevision($event.itemId, $event.fileIndex)" (deleteClicked)="openVerifyDelete($event.name, $event.itemType, $event.itemId)" (externalFileRemoved)="externalFileRemoved($event)" (loadIcon)="getIcon($event)" (startLoad)="startLoad()" (loadShare)="loadShare()" (downloadCancelled)="cancelDownload($event)">
					</mfiles-row>
				</ng-container>
			</tbody>
		</table>
	</div>
</div>

<ng-template #deleteDialog>
	<div class="modal-header">
		<h5 class="modal-title"><em class="fas fa-trash"></em> Delete</h5>
	</div>
	<div class="modal-body share-dialog">
		Are you sure you want to delete {{ deleteName }}?
	</div>
	<div class="modal-footer no-bg">
		<button type="button" class="btn btn-primary btn-md" (click)="deleteObject()">Delete</button>
		<button type="button" class="btn btn-default btn-md" data-dismiss="modal" (click)="modalRef.hide()">Cancel</button>
	</div>
</ng-template>

<ng-template #viewerModal>
	<div class="modal-body viewer">
		<div class="viewer-container" *ngIf="displayTab === 'viewer'">
			<app-widget-viewer [widgetSettings]="viewerModalSettings" [isExternal]="true" [token]="token"></app-widget-viewer>
		</div>
		<div *ngIf="displayTab === 'comments'">
			<div [ngClass]="{'loading in': loadingComments}">
				<div perfectScrollbar class="custom-scroll">
					<div class="metadata-table-outer">
						Comments ({{ commentsCount }})
						<div *ngIf="comments" class="comments">
							<div class="rootCommentResponse">
								<ng-container *ngIf="!authService.isAuthenticated()">
									<input type="text" name="commentUser" [(ngModel)]="newComment.user" placeholder="Name" class="form-control">
									<input type="text" name="commentEmail" [(ngModel)]="newComment.email" placeholder="E-mail (optional)" class="form-control">
								</ng-container>
								<textarea name="comment" [(ngModel)]="newComment.comment" placeholder="Enter a comment..." class="form-control"></textarea>
								<a href="javascript:" (click)="clearCommentForm()"><button type="reset">Cancel</button></a>
								<a><button type="button" (click)="onCommentSubmit()" [disabled]="!newComment.user || !newComment.comment || !isValidEmail()">Reply</button></a>
							</div>
							<app-comments *ngFor="let comment of comments" (newComment)="onNewComment($event)" [comment]="comment" [item]="sharedItem.id"></app-comments>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="displayTab === 'properties'">
			<div [ngClass]="{'loading in': loadingProperties}">
				<div perfectScrollbar class="custom-scroll">
					<div class="metadata-table-outer">
						<ng-container *ngIf="docEditProps.length > 0">
							<table class="table">
								<thead>
									<tr>
										<th id="property">Property</th>
										<th id="value">Value</th>
										<th id="values" class="center" *ngIf="hasEditableMultiSelect()">Multi-Select Values</th>
										<th id="remove" *ngIf="permissions.indexOf(7) > -1"></th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let prop of docEditProps; let i = index">
										<td>
											{{ prop.name }}
										</td>
										<ng-container *ngIf="prop.editable">
											<td>
												<div *ngIf="prop.dataType === 1">
													<input type="text" [(ngModel)]="prop.value" class="form-control" [disabled]="!prop.editable || permissions.indexOf(7) === -1">
												</div>
												<div *ngIf="prop.dataType === 2 || prop.dataType === 3">
													<input type="number" [(ngModel)]="prop.value" class="form-control" [disabled]="!prop.editable || permissions.indexOf(7) === -1">
												</div>
												<div *ngIf="prop.dataType === 5 || prop.dataType === 6 || prop.dataType === 7">
													<input type="text" [(ngModel)]="prop.value" bsDatepicker class="form-control" [disabled]="!prop.editable || permissions.indexOf(7) === -1">
												</div>
												<div *ngIf="prop.dataType === 8">
													<div class="switch-row">
														<div class="switch">
															<input [id]="'additionalProps' + i" type="checkbox" class="switch-input" [(ngModel)]="prop.value" (ngModelChange)="onChange()" [disabled]="!prop.editable || permissions.indexOf(7) === -1" />
															<label [for]="'additionalProps' + i" class="switch-label">Switch</label>
														</div>
													</div>
												</div>
												<div *ngIf="prop.dataType === 9">
													<ng-select class="typeahead" [items]="optionLists[prop.id].items" [clearable]="false" bindLabel="name" bindValue="id" [placeholder]="prop.value ? prop.name : 'Select Value'" [(ngModel)]="prop.value" [disabled]="!prop.editable || permissions.indexOf(7) === -1">
													</ng-select>
												</div>
												<div *ngIf="prop.dataType === 10">
													<ng-select class="typeahead" [items]="optionLists[prop.id].items" [clearable]="false" bindLabel="name" bindValue="id" placeholder="Select Values" (change)="editMultiselectChanged(i, $event)" [disabled]="!prop.editable || permissions.indexOf(7) === -1">
													</ng-select>
												</div>
												<div *ngIf="prop.dataType === 13">
													<textarea [(ngModel)]="prop.value" class="form-control" [disabled]="!prop.editable || permissions.indexOf(7) === -1"></textarea>
												</div>
											</td>
											<td *ngIf="hasEditableMultiSelect()">
												<div *ngIf="prop.dataType === 10">
													<div *ngFor="let value of prop.value; let j = index">
														{{value.name}} <em class="fas fa-times red" *ngIf="prop.editable && permissions.indexOf(7) > -1" (click)="removeEditMultiselectOption(prop, j)"></em>
													</div>
												</div>
											</td>
											<td *ngIf="permissions.indexOf(7) > -1">
												<button *ngIf="prop.editable" class="btn-xs btn btn-danger" (click)="removeProp(i)">Remove</button>
											</td>
										</ng-container>
										<ng-container *ngIf="!prop.editable">
											<td>
												{{ prop.displayValue }}
											</td>
											<td *ngIf="hasEditableMultiSelect()"></td>
											<td *ngIf="permissions.indexOf(7) > -1"></td>
										</ng-container>
									</tr>
								</tbody>
							</table>
							<button type="button" class="btn btn-success pull-right" *ngIf="permissions.indexOf(7) > -1 && atLeastOneEditProp" (click)="saveProperties()">Update Properties</button>
						</ng-container>
						<ng-container *ngIf="docEditProps.length === 0">
							This share has not been configured to display any properties.
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer message-footer">
		<div class="col-md-6 left">
			<button class="btn btn-light btn-md" (click)="prevFileClicked()" *ngIf="sharedItems.length > 0" [disabled]="isFirstDoc()">Prev</button>
			<button class="btn btn-light btn-md" (click)="nextFileClicked()" *ngIf="sharedItems.length > 0" [disabled]="isLastDoc()">Next</button>
		</div>
		<div class="col-md-6">
			<button tooltip="Metadata" class="btn btn-light btn-md" *ngIf="docEditProps.length > 0" (click)="displayTab = 'properties'"><em class="fas fa-list"></em></button>
			<button tooltip="Comments" class="btn btn-light btn-md" *ngIf="permissions.indexOf(2) > -1" (click)="loadComments()"><em class="fas fa-comments"></em></button>
			<button tooltip="Document Viewer" class="btn btn-light btn-md" (click)="loadViewer()"><em class="fas fa-file-alt"></em></button>
			<button class="btn btn-light btn-md" (click)="closeViewerModal()">Close</button>
		</div>
	</div>
</ng-template>

<ng-template #uploadProgressModal>
	<div class="modal-header">
		<h5 class="modal-title"><em class="fas fa-upload"></em>Uploading Files</h5>
	</div>
	<div class="modal-body upload-progress-modal-body" [ngClass]="{'loading in': uploadsCommitting}" [ngStyle]="{'overflow-y': uploadsCommitting ? 'hidden' : 'auto'}">
		<div *ngFor="let progress of uploadProgressStats | keyvalue" class="upload-progress-section">
			<div>{{ progress.key }}</div>
			<ng-container *ngIf="progress.value === 'ERROR'; else elseTemplate">
				<div class="upload-progress-error">
					<em class="fas fa-exclamation-circle error"></em>
					An error occurred while uploading this file. Please try again later.
				</div>
			</ng-container>
			<ng-template #elseTemplate>
				<ng-container *ngIf="progress.value === 'EMPTY'; else notEmptyTemplate">
					<div class="upload-progress-empty">
						<em class="fas fa-exclamation-triangle"></em>
						This file has no content. It will be skipped.
					</div>
				</ng-container>
				<ng-template #notEmptyTemplate>
					<div class="upload-progress-container">
						<div class="upload-progress-bar">
							<mat-progress-bar mode="determinate" [value]="progress.value">
							</mat-progress-bar>
						</div>
						<div class="upload-progress-num">{{ progress.value }}%</div>
					</div>
				</ng-template>
			</ng-template>

		</div>
	</div>
	<div class="modal-footer message-footer">
		<span id="uploadProgressMessage">{{ uploadProgressMessage }}</span>
		<button type="button" class="btn btn-md btn-danger" (click)="cancelUpload()">Cancel</button>
	</div>
</ng-template>